
import { RangerSourceMapEntityDecorator } from './ranger-source-map.decorator';
import { RangerSourceMap } from './ranger-source-map.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class RangerSourceMapTypeInfoBase implements CrudTypeInfo<RangerSourceMap, string> {
  name = 'Ranger Source Map';
  entityDecorator = new RangerSourceMapEntityDecorator();
  
  createAuthorities = ['WRITE_RANGER_SOURCE_MAP'];
  editAuthorities = ['WRITE_RANGER_SOURCE_MAP'];
  deleteAuthorities = ['WRITE_RANGER_SOURCE_MAP'];
  viewAuthorities = ['READ_RANGER_SOURCE_MAP'];
  
  searchRouteBase = ['/rangersourcemap/search'];
  createRouteBase = ['/rangersourcemap/create'];
  editRouteBase = ['/rangersourcemap/edit'];
  viewRouteBase = ['/rangersourcemap/view'];
  
  description(item: RangerSourceMap): string {
    return '' +  item.rangerSourceMapId +  ' - ' +  item.sourceName;
  }
}



